/* eslint-disable import/prefer-default-export */
export const getRouteAndParams = ({ customer_id, property_id = null }) => {
  if (property_id) {
    return {
      route: `/customers/${customer_id}/properties/${property_id}`,
      params: {
        include: [
          'schedules.schedulable',
          'schedules.scheduleEvents',
          'requiredServices.service',
          'requiredServices.schedule',
          'requiredServices.contractor.user',
          'recommendations.service',
          'recommendations.schedule',
          'recommendations.contractor.user',
          'order',
          'prices.service',
        ],
      },
    };
  }

  return {
    route: `/customers/${customer_id}`,
    params: {
      include: [
        'properties.schedules.schedulable',
        'properties.requiredServices.service',
        'properties.requiredServices.schedule',
        'properties.requiredServices.contractor.user',
        'properties.recommendations.service',
        'properties.recommendations.schedule',
        'properties.recommendations.contractor.user',
        'properties.order',
        'properties.prices.service',
        'properties.market',
        'lastcompletedscheduleevent.contractor.user',
        'lastcompletedscheduleevent.reviews', // will no longer need once API-6887 is complete
      ],
    },
  };
};
